export default __webpack_public_path__ + "static/media/cdjr.304357ed.gif";